import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../../theme';
import { BaseBodyTextStyles, StyledBodyTextProps } from '../Body';
import { BaseUITextStyles } from '../UIText';

type LinkTextContext = 'primary' | 'secondary';
type StyleType = 'body' | 'ui';

type BaseLinkTextProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

type StyledLinkTextProps = {
  context: LinkTextContext;
  isUnderlined: boolean;
  isUnderlinedOnHover?: boolean;
  styleType?: StyleType;
};

export type CombinedLinkTextProps = StyledBodyTextProps & StyledLinkTextProps;

type CombinedAnchorLinkTextProps = BaseLinkTextProps & CombinedLinkTextProps;

const contextStyles = {
  primary: theme.colors.primary.graysRed,
  secondary: theme.colors.system.systemBlue,
};

const LinkTextContextStyles = css<StyledLinkTextProps>`
  color: ${({ context }) => contextStyles[context]};
`;

export const LinkTextStyles = css<CombinedLinkTextProps>`
  ${({ styleType }) =>
    styleType === 'body' ? BaseBodyTextStyles : BaseUITextStyles};

  ${LinkTextContextStyles};

  text-decoration: ${({ isUnderlined }) =>
    isUnderlined ? 'underline' : 'none'};

  :hover {
    cursor: pointer;
    ${({ isUnderlined, isUnderlinedOnHover }) =>
      isUnderlined ? 'underline' : isUnderlinedOnHover ? 'underline' : 'none'};
  }
`;

const BaseLinkText = styled.a<CombinedAnchorLinkTextProps>`
  ${LinkTextStyles};
`;

export type LinkTextProps = Partial<CombinedAnchorLinkTextProps>;

export const LinkText: React.FC<LinkTextProps> = ({
  children,
  context = 'secondary',
  size = 'md',
  isUnderlined = false,
  isUnderlinedOnHover = false,
  styleType = 'body',
  ...props
}) => {
  return (
    <BaseLinkText
      size={size}
      context={context}
      isUnderlined={isUnderlined}
      isUnderlinedOnHover={isUnderlinedOnHover}
      styleType={styleType}
      {...props}
    >
      {children}
    </BaseLinkText>
  );
};
